import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  ShopChannelRootTaxonDetailGQL,
  ShopTaxonChildrenGQL,
  ShopTaxonDetailByIdGQL,
  ShopTaxonStateGQL,
} from './gql/shop-taxon.gql.generated';
import {
  IShopChannelRootTaxon,
  IShopTaxonChild,
  IShopTaxonDetail,
  IShopTaxonState,
} from './types/shop-taxon';

@Injectable()
export class ShopTaxonService {
  constructor(
    private readonly taxonDetailByIdGql: ShopTaxonDetailByIdGQL,
    private readonly channelRootTaxonGql: ShopChannelRootTaxonDetailGQL,
    private readonly shopTaxonStateGQL: ShopTaxonStateGQL,
    private readonly shopTaxonChildrenGQL: ShopTaxonChildrenGQL,
  ) {}

  fetchTaxonDetail(
    id: number,
    locale: string,
    channelCode: string,
    regionId?: number | null,
  ): Observable<IShopTaxonDetail> {
    return this.taxonDetailByIdGql
      .fetch({ id, locale, channelCode, regionId })
      .pipe(map((r) => r.data.shopTaxon));
  }

  fetchTaxonState(id: number, locale: string, channelCode: string): Observable<IShopTaxonState> {
    return this.shopTaxonStateGQL
      .fetch({ id, locale, channelCode })
      .pipe(map((r) => r.data.shopTaxon));
  }

  fetchTaxonChildren(
    id: number,
    locale: string,
    channelCode: string,
    regionId?: number | null,
  ): Observable<IShopTaxonChild[]> {
    return this.shopTaxonChildrenGQL
      .fetch({ id, locale, channelCode, regionId })
      .pipe(map((r) => r.data.shopTaxon.children));
  }

  fetchChannelRootTaxonDetail(
    channelCode: string,
    locale: string,
    regionId?: number | null,
  ): Observable<IShopChannelRootTaxon> {
    return this.channelRootTaxonGql
      .fetch({ channelCode, locale, regionId })
      .pipe(map((r) => r.data.shopChannelRootTaxon));
  }
}
